interface WriteAccessUser {
  allows_write_to_pm?: boolean
}

interface WriteAccessWebApp {
  requestWriteAccess?: (callback?: (granted: boolean) => void) => void
}

/** Код ошибки бэкенда, когда бот не может написать пользователю в личку. */
export const WRITE_ACCESS_REQUIRED_CODE = 'WRITE_ACCESS_REQUIRED'

// initDataUnsafe.user.allows_write_to_pm не обновляется после выдачи разрешения,
// поэтому запоминаем результат запроса в рамках сессии.
let grantedInSession = false
// Telegram не показывает второй попап, пока открыт первый — делим один запрос между вызовами.
let pendingRequest: Promise<boolean> | null = null

/**
 * Запрашивает у Telegram разрешение боту писать пользователю в личку и ждёт ответа.
 * true — разрешение есть (или клиент не поддерживает запрос — тогда решает бэкенд),
 * false — пользователь отказал. force — спросить, даже если разрешение по initData уже есть
 * (бэкенд сообщил, что написать не может).
 */
export function ensureWriteAccess(
  webApp: WriteAccessWebApp | null | undefined,
  user?: WriteAccessUser | null,
  options?: { force?: boolean },
): Promise<boolean> {
  if (!options?.force && (grantedInSession || user?.allows_write_to_pm === true)) {
    return Promise.resolve(true)
  }
  if (!webApp?.requestWriteAccess) return Promise.resolve(true)
  if (pendingRequest) return pendingRequest

  pendingRequest = new Promise<boolean>((resolve) => {
    try {
      webApp.requestWriteAccess!((granted) => {
        if (granted) grantedInSession = true
        resolve(granted)
      })
    } catch {
      // Метод недоступен в текущей версии клиента — не блокируем, проверит бэкенд
      resolve(true)
    }
  }).finally(() => {
    pendingRequest = null
  })

  return pendingRequest
}

/** Запрос разрешения без ожидания ответа — для показа при старте приложения. */
export function requestWriteAccessIfNeeded(
  webApp: WriteAccessWebApp | null | undefined,
  user?: WriteAccessUser | null,
): void {
  void ensureWriteAccess(webApp, user)
}
